import { isUndefined } from 'lodash-es'
import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

export const useValidateStep = (
  stepPaths: Record<string, number>,
  stepValidations: Array<{
    step: number
    validate: () => boolean
    redirect: string
  }>,
) => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const step = searchParams?.get('step') || 'intro'

  useEffect(() => {
    const currentStep = stepPaths[step]

    if (isUndefined(currentStep)) return

    const failedStep = stepValidations.find(
      ({ step, validate }) => currentStep >= step && !validate(),
    )

    if (failedStep) {
      router.replace(failedStep.redirect)
    }
  }, [step])
}
